import React from "react";

const MoraChainHero = () => {
  return (
    <div className="container-fluid px-0">
      <div className="row">
        <div className="col-lg-7">
          <div className="left">
            <h1 className="text-start">What is Morachain?</h1>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>
          </div>
        </div>
        <div className="col-lg-5">
          <img className="w-100" src="./assets/imgs/coin-lg.png" alt="coin" />
        </div>
      </div>
    </div>
  );
};

export default MoraChainHero;
